export const legalDocuments = {
  "privacy": {
    "title": "Privacy Policy",
    "platform": "OneApplyHub",
    "website": "www.oneapplyhub.co.za",
    "effectiveDate": "6 April 2026",
    "version": "Version 1.0",
    "sections": [
      {
        "heading": "1. Introduction",
        "paragraphs": [
          "OneApplyHub (Pty) Ltd, trading as OneApplyHub, operates the digital platform accessible at www.oneapplyhub.co.za (the \"Platform\"). We are committed to protecting the personal information of all users in accordance with the Protection of Personal Information Act 4 of 2013 (\"POPIA\") and all applicable South African law.",
          "This Privacy Policy explains what personal information we collect, why we collect it, how we use it, who we share it with, and what your rights are. By using our Platform, you confirm that you have read, understood, and agree to this Privacy Policy."
        ]
      },
      {
        "heading": "2. Who We Are",
        "paragraphs": [
          "Platform Name",
          "OneApplyHub",
          "Legal Entity",
          "OneApplyHub (Pty) Ltd",
          "Website",
          "www.oneapplyhub.co.za",
          "Email",
          "info@oneapplyhub.co.za",
          "Country",
          "Republic of South Africa",
          "OneApplyHub is a technology intermediary platform. We do not own, manage, or operate any student accommodation. We do not collect rent, hold deposits, or enter into lease agreements. Our sole function is to simplify and centralise the process by which students find and apply for student accommodation from registered accommodation providers."
        ]
      },
      {
        "heading": "3. What Personal Information We Collect",
        "paragraphs": [
          "3.1 From Students",
          "When a student registers on and uses the Platform, we may collect:",
          "Full name and surname",
          "South African ID number or passport number",
          "Date of birth",
          "Contact details: email address and mobile number",
          "Residential address",
          "Name of higher education institution and student number",
          "Year of study and faculty/course",
          "Accommodation preferences (location, price range, room type)",
          "Any supporting documents uploaded during application (e.g. proof of registration, parent/guardian contact details)",
          "Login credentials (stored in encrypted form)",
          "Device and usage data collected automatically (see Section 7)",
          "3.2 From Accommodation Providers",
          "When an accommodation provider registers on the Platform, we may collect:",
          "Business name and registration number",
          "Contact person name and details",
          "Physical address of the accommodation",
          "Banking details (for invoicing purposes only)",
          "Accommodation listing information and photographs"
        ]
      },
      {
        "heading": "4. Why We Collect Your Personal Information",
        "paragraphs": [
          "We collect and process personal information only for the following specific, lawful purposes:",
          "To create and manage your user account on the Platform",
          "To enable students to search for, view, and apply for student accommodation",
          "To transmit student applications to accommodation providers the student has selected",
          "To communicate with you about your application status and Platform updates",
          "To verify your identity and eligibility",
          "To comply with our legal obligations under POPIA, the Consumer Protection Act, and other applicable laws",
          "To improve the Platform and user experience through analytics",
          "We will not use your personal information for any purpose not stated above without first obtaining your consent."
        ]
      },
      {
        "heading": "5. Legal Basis for Processing",
        "paragraphs": [
          "We process your personal information on the following lawful bases:",
          "Consent: You have given us explicit, informed consent to process your information when you register and tick the consent checkbox on our Platform.",
          "Contractual necessity: Processing is necessary to provide you with the services you requested when creating an account.",
          "Legal obligation: Where required by POPIA or other applicable legislation.",
          "Legitimate interest: To maintain the security and integrity of the Platform."
        ]
      },
      {
        "heading": "6. How We Share Your Information",
        "paragraphs": [
          "OneApplyHub does not sell, rent, or trade your personal information. We share your information only in the following circumstances:",
          "6.1 With Accommodation Providers",
          "When a student submits an application for a specific accommodation listing, we will share that student's application information with the relevant accommodation provider. By submitting an application, the student consents to this sharing. The accommodation provider becomes an independent responsible party for that information once received.",
          "6.2 With Service Providers",
          "We may share information with trusted third-party service providers who assist us in operating the Platform (e.g. cloud hosting, email services). These parties are required to process data only on our instructions and in compliance with POPIA.",
          "6.3 Legal Requirements",
          "We may disclose personal information if required to do so by law, court order, or a lawful request by a South African regulatory or law enforcement authority.",
          "6.4 Business Transfers",
          "In the event of a merger, acquisition, or sale of assets, your personal information may be transferred. We will notify you before your information is transferred and becomes subject to a different Privacy Policy."
        ]
      },
      {
        "heading": "7. Cookies and Automatic Data Collection",
        "paragraphs": [
          "Our Platform uses cookies and similar technologies to collect certain information automatically, including:",
          "IP address and browser type",
          "Pages visited and time spent on the Platform",
          "Device type and operating system",
          "We use this information to analyse usage trends and improve the Platform. You may disable cookies in your browser settings; however, some features of the Platform may not function correctly if you do so. We will request your consent for non-essential cookies when you first visit the Platform."
        ]
      },
      {
        "heading": "8. How Long We Keep Your Information",
        "paragraphs": [
          "We retain your personal information only for as long as is necessary for the purposes described in this Privacy Policy or as required by law. Specifically:",
          "Active student accounts: Retained for the duration of your active use of the Platform plus 3 years.",
          "Completed applications: Retained for 3 years from the date of application.",
          "Accommodation provider data: Retained for the duration of the listing agreement plus 5 years for financial record-keeping purposes.",
          "After these periods, your data will be securely deleted or anonymised."
        ]
      },
      {
        "heading": "9. How We Protect Your Information",
        "paragraphs": [
          "We implement reasonable and appropriate technical and organisational security measures to protect your personal information against unauthorised access, loss, misuse, alteration, or destruction. These measures include:",
          "SSL/TLS encryption on all data transmissions",
          "Secure password hashing",
          "Access controls limiting staff access to personal data on a need-to-know basis",
          "Regular security reviews of our systems",
          "Despite our precautions, no system is completely secure. In the event of a data breach that is likely to affect your rights and interests, we will notify you and the Information Regulator as required by POPIA."
        ]
      },
      {
        "heading": "10. Your Rights Under POPIA",
        "paragraphs": [
          "As a data subject under POPIA, you have the following rights:",
          "Right of access: Request a copy of the personal information we hold about you.",
          "Right to correction: Request that we correct inaccurate or incomplete information.",
          "Right to deletion: Request that we delete your personal information, subject to our legal retention obligations.",
          "Right to object: Object to the processing of your personal information in certain circumstances.",
          "Right to withdraw consent: Withdraw your consent at any time, without affecting the lawfulness of processing prior to withdrawal.",
          "Right to lodge a complaint: Lodge a complaint with the Information Regulator of South Africa at www.inforegulator.org.za.",
          "To exercise any of these rights, contact us at: info@oneapplyhub.co.za. We will respond within 30 days."
        ]
      },
      {
        "heading": "11. Cross-Border Transfers",
        "paragraphs": [
          "We primarily store your data within South Africa. If we transfer personal information outside South Africa (e.g. to an international cloud hosting provider), we will ensure that the recipient country provides an adequate level of protection, or we will obtain your consent or put in place appropriate safeguards as required by POPIA."
        ]
      },
      {
        "heading": "12. Children and Minors",
        "paragraphs": [
          "Our Platform is intended for students enrolled at higher education institutions. If a user is under the age of 18, we require the consent of a parent or legal guardian before their personal information is collected. We do not knowingly collect personal information from children under 13."
        ]
      },
      {
        "heading": "13. Changes to This Privacy Policy",
        "paragraphs": [
          "We may update this Privacy Policy from time to time to reflect changes in our practices or the law. We will notify you of material changes by email or by placing a prominent notice on the Platform. The updated policy will take effect 30 days after notice is given, unless a shorter notice period is required by law."
        ]
      },
      {
        "heading": "14. Contact Our Information Officer",
        "paragraphs": [
          "For any privacy-related queries, requests, or complaints, please contact our designated Information Officer:",
          "Organisation",
          "OneApplyHub (Pty) Ltd",
          "Role",
          "Information Officer",
          "Email",
          "info@oneapplyhub.co.za",
          "Website",
          "www.oneapplyhub.co.za",
          "Regulator",
          "Information Regulator (SA) \u2014 www.inforegulator.org.za",
          "POPIA Registration No.",
          "2026-016454 (Information Regulator of South Africa)"
        ]
      }
    ]
  },
  "terms": {
    "title": "Terms And Conditions",
    "platform": "OneApplyHub",
    "website": "www.oneapplyhub.co.za",
    "effectiveDate": "18 May 2026",
    "version": "Version 2.0",
    "sections": [
      {
        "heading": "1. Definitions",
        "paragraphs": [
          "In these Terms and Conditions, unless the context requires otherwise:",
          "\"OneApplyHub\", \"we\", \"us\", \"our\" means OneApplyHub (Pty) Ltd and its Platform.",
          "\"Platform\" means the website and digital services available at www.oneapplyhub.co.za.",
          "\"Student\" or \"User\" means any individual who registers on and uses the Platform to search for and apply for student accommodation.",
          "\"Accommodation Provider\" means any registered entity that lists student accommodation on the Platform.",
          "\"Application\" means a student's submission of interest and supporting information to an Accommodation Provider via the Platform.",
          "\"Listing\" means an accommodation unit or property listed by an Accommodation Provider on the Platform.",
          "\"Lease Agreement\" means any agreement entered into directly between a Student and an Accommodation Provider regarding occupancy."
        ]
      },
      {
        "heading": "2. Nature of the Platform \u2014 Important Disclaimer",
        "paragraphs": [
          "PLEASE READ THIS SECTION CAREFULLY.",
          "OneApplyHub is a technology intermediary platform only. We provide a centralised digital tool that enables students to discover and apply for student accommodation.",
          "OneApplyHub:",
          "Does NOT own, operate, manage, or control any student accommodation",
          "Does NOT act as a property agent, letting agent, rental agent, estate agent, or property manager",
          "Does NOT collect rent, hold deposits, or handle any money on behalf of any party",
          "Does NOT enter into any lease agreement on behalf of any party",
          "Does NOT guarantee the availability, quality, safety, or suitability of any accommodation listed",
          "Does NOT verify the accuracy of all information provided by Accommodation Providers",
          "Any Lease Agreement entered into following an introduction made via the Platform is solely between the Student and the Accommodation Provider. OneApplyHub is not a party to that agreement and accepts no liability arising from it."
        ]
      },
      {
        "heading": "3. Acceptance of Terms",
        "paragraphs": [
          "By registering on or using the Platform, you confirm that you:",
          "Are 18 years of age or older, OR have the consent of a parent or legal guardian",
          "Are enrolled at, or intend to enrol at, a recognised South African higher education institution",
          "Have read and understood these Terms and Conditions in full",
          "Agree to be bound by these Terms and Conditions",
          "Have read and agree to our Privacy Policy",
          "If you do not agree to these Terms and Conditions, you must not use the Platform."
        ]
      },
      {
        "heading": "4. Student Account Registration",
        "paragraphs": [
          "To access the Application functionality, you must register for an account. You agree to:",
          "Provide accurate, current, and complete information during registration",
          "Maintain the security of your password and not share your login credentials",
          "Notify us immediately of any unauthorised use of your account at info@oneapplyhub.co.za",
          "Take full responsibility for all activities that occur under your account",
          "OneApplyHub reserves the right to suspend or terminate accounts that contain false information or that are used in violation of these Terms."
        ]
      },
      {
        "heading": "5. The Application Process",
        "paragraphs": [
          "When a Student submits an Application to an Accommodation Provider via the Platform:",
          "The Student's personal information and application documents are transmitted to the relevant Accommodation Provider.",
          "The Accommodation Provider will independently review the Application and determine whether to accept or decline it.",
          "OneApplyHub does not guarantee that any Application will be successful.",
          "Any offer of accommodation, and the terms thereof, is made solely by the Accommodation Provider.",
          "Any Lease Agreement is concluded directly and independently between the Student and the Accommodation Provider, outside of the Platform.",
          "OneApplyHub bears no responsibility for the outcome of any Application or for the terms of any Lease Agreement."
        ]
      },
      {
        "heading": "6. Student Obligations",
        "paragraphs": [
          "As a Student using the Platform, you agree to:",
          "Only submit accurate and truthful information in your applications",
          "Not misrepresent your academic status, identity, or financial situation",
          "Use the Platform solely for its intended purpose of finding student accommodation",
          "Not use the Platform for any unlawful, fraudulent, or harmful purpose",
          "Not attempt to circumvent, hack, or disrupt the Platform's systems",
          "Comply with all applicable South African laws in your use of the Platform"
        ]
      },
      {
        "heading": "7. Accommodation Provider Obligations",
        "paragraphs": [
          "Accommodation Providers agree to:",
          "Ensure all Listings are accurate, current, and not misleading",
          "Only list accommodation that is legally available for student occupation",
          "Comply with all applicable property laws, health and safety regulations, and student housing standards",
          "Process student applications fairly and in compliance with the Consumer Protection Act and applicable anti-discrimination legislation",
          "Not misuse student personal information received via the Platform",
          "Remove Listings that are no longer available promptly"
        ]
      },
      {
        "heading": "8. Intellectual Property",
        "paragraphs": [
          "All content on the Platform, including but not limited to the OneApplyHub name, logo, design, text, software, and database, is the intellectual property of OneApplyHub (Pty) Ltd and is protected under South African and international intellectual property laws.",
          "You may not copy, reproduce, distribute, modify, or create derivative works of any content on the Platform without our express written permission."
        ]
      },
      {
        "heading": "9. Limitation of Liability",
        "paragraphs": [
          "To the maximum extent permitted by South African law:",
          "OneApplyHub provides the Platform on an \"as is\" and \"as available\" basis without warranties of any kind.",
          "We do not warrant that the Platform will be uninterrupted, error-free, or free from viruses or harmful components.",
          "We are not liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of the Platform or from any accommodation arrangement made through the Platform.",
          "Under no circumstances shall we as the provider be liable for any incidents, damages, loss, death, or liabilities arising from or in connection to the provided accommodation, housing or related facilities. The user hereby waivers any claims, whether sounding in contract, delict or criminal law, against us as the platform. Furthermore, the user agrees that we as the platform shall not be cited, joined or named as a party, co-defendant or third party to any lawsuit, arbitration or legal dispute/ proceedings relating to the premises.",
          "Our total aggregate liability to any user shall not exceed R500.00 (Five Hundred Rand).",
          "This limitation does not exclude liability for gross negligence or wilful misconduct, or any liability that cannot lawfully be excluded under the Consumer Protection Act 68 of 2008."
        ]
      },
      {
        "heading": "10. Indemnity",
        "paragraphs": [
          "You agree to indemnify and hold harmless OneApplyHub, its directors, employees, and agents from and against any claims, losses, damages, costs, and expenses (including legal fees) arising from:",
          "Your breach of these Terms and Conditions",
          "Your use or misuse of the Platform",
          "Any dispute between you and an Accommodation Provider",
          "Any inaccurate information you submitted on the Platform"
        ]
      },
      {
        "heading": "11. Privacy and Data Protection",
        "paragraphs": [
          "Your personal information is collected and processed in accordance with our Privacy Policy, which is incorporated into and forms part of these Terms and Conditions. By accepting these Terms, you also accept our Privacy Policy. Please review it carefully before using the Platform.",
          "By submitting an Application to an Accommodation Provider, you give your informed consent for your application information to be shared with that specific provider."
        ]
      },
      {
        "heading": "12. Suspension and Termination",
        "paragraphs": [
          "OneApplyHub reserves the right to suspend or terminate your access to the Platform, with or without notice, if:",
          "You breach any provision of these Terms and Conditions",
          "We reasonably suspect fraudulent or unlawful activity",
          "You provide false or misleading information",
          "You may terminate your account at any time by contacting info@oneapplyhub.co.za. On termination, we will handle your personal data in accordance with our Privacy Policy and applicable law."
        ]
      },
      {
        "heading": "13. Changes to the Platform and Terms",
        "paragraphs": [
          "OneApplyHub reserves the right to modify, suspend, or discontinue the Platform or any part thereof at any time. We also reserve the right to update these Terms and Conditions. We will notify users of material changes with 30 days' notice via email or a notice on the Platform. Continued use of the Platform after such notice constitutes your acceptance of the updated Terms."
        ]
      },
      {
        "heading": "14. Governing Law and Dispute Resolution",
        "paragraphs": [
          "These Terms and Conditions are governed by and construed in accordance with the laws of the Republic of South Africa. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the South African courts.",
          "Parties agree to first attempt to resolve any dispute amicably through good-faith negotiations before resorting to formal legal proceedings."
        ]
      },
      {
        "heading": "15. Contact Us",
        "paragraphs": [
          "For any queries regarding these Terms and Conditions, contact us at:",
          "Platform",
          "OneApplyHub",
          "Email",
          "info@oneapplyhub.co.za",
          "Website",
          "www.oneapplyhub.co.za"
        ]
      }
    ]
  }
};
